<template>
    <div class="entrees_cart_wrap">
       <div class="container">
              <div class="title_text_ent">
                <h1 >
                    <span class="large_sm_ent">{{get_local_string.string_5}} </span>
                    <span class="small_sm_ent">{{get_local_string.string_103}}</span>
                     <div class="a_ent">
                <router-link class="tilbetailng" to="/cart" uk-toggle="target: #offcanvas-flip" >
                <span>{{get_local_string.string_4}}</span>
                </router-link>
                     </div>
                     </h1>
                 
        
           </div>
           <template v-for="group_entress in all_data_cart.entrees" >
           <div class="group_entress" v-if="group_entress.data.length" :key="group_entress.id">
               <!-- {{group_entress}} -->
               <div class="title_group">
                   <h2>{{group_entress.name}}</h2>
               </div>
               <div class="row">
                   <div class="col-xl-2 col-lg-3 col-md-4 col-6 box_single" v-for="box_entress in group_entress.data" :key="box_entress.id">
                       <div class="box_entress">
                           <img :src="box_entress.image" alt="">
                           <span class="name_entress">{{box_entress.name}}</span>
                           <span class="price_entress"> {{box_entress.price}}  {{get_setting_app.payment.currency}}</span>
                           <template v-if="box_entress.cart_qty>0">
                                <b-field class="d-inline-block select_ddl">
                                    <b-select v-model="box_entress.cart_qty" @input.native="updateItem(box_entress , $event)" class="qty_side" name="" id="" >
                                        <template v-for="qty in box_entress.cart_qty+3" >
                                                <option :value="qty" :key="qty.id">{{qty}}</option>
                                            </template>
                                    </b-select>
                            </b-field>
                           </template>
                           <template v-else>
                               <b-button @click.native="add_entress_cart(box_entress)" class="add_entrss" type="is-success">
                             <i class="fas fa-plus"></i>
                           </b-button>
                           </template>
                       </div>
                   </div>
               </div>
           </div>
              </template>
       </div>
    </div>
</template>
<script>
import $ from 'jquery';
import { mapActions, mapGetters , mapMutations} from 'vuex'
export default {
  name:'entrees-cart',
  data(){
      return{
            custom_obj: {
                    food_id: null,
                    default:0,
                    dough_id: null,
                    size_id: null,
                    qty: 1,
                    component: [],
                    extra: [],
                    price: null,
                    platform:'web'
             },
      }
  },
  computed:{
      ...mapGetters({
           all_data_cart:'all_data_cart',
           get_setting_app:'get_setting_app',
             get_local_string:'get_local_string'
      })
  },
  methods:{
      ...mapActions({
           add_to_cart:'add_to_cart',
            update_data_cart:'update_data_cart',
      }),
       ...mapMutations({
            SET_GRAND_TOTAL:'SET_GRAND_TOTAL',
            SET_CART_COUNT :'SET_CART_COUNT'
        }),
            //function on click button add
            add_entress_cart(add_entress_cart) {
                this.custom_obj.food_id  = add_entress_cart.id;
                this.custom_obj.price = add_entress_cart.price;
                console.log(this.custom_obj);
                this.add_to_cart(this.custom_obj).then(()=>{
                     this.uk.offcanvas($('#offcanvas-flip')).show();
                     $('.list_added_item').find('.move_left').removeClass('modify');
                })
            },
             updateItem(item , event){
            let item_updete = {
             item_id : item.cart_id , 
             item_qty: event.target.value
            }
             this.total_price = 0;
             this.local_qty = 0;
              setTimeout(()=>{
               document.querySelectorAll('.move_left_side').forEach((elem)=>{
               this.total_price += (parseFloat( elem.getAttribute('price_data')) * parseFloat(elem.getAttribute('qty')));
               this.local_qty += parseInt(elem.getAttribute('qty'))
           })
            // call animation count 
            // this.animaion_count(this.total_price);
            // end
             this.SET_GRAND_TOTAL(parseFloat(this.total_price));
             this.SET_CART_COUNT(this.local_qty);
             },5)
            // end animation 
            console.log(item_updete);
            this.update_data_cart(item_updete);
            event.path[5].classList.toggle('modify');
        },
  },
   mounted(){
         document.documentElement.classList.add('entressPage');
    this.uk.offcanvas($('#offcanvas-flip')).hide();
  },
    destroyed(){
     document.documentElement.classList.remove('entressPage');
    }
}
</script>
<style lang="scss">
.list_added_item{
    padding-bottom: 30px;
    overflow-y: unset !important;
}
.small_sm_ent{
    font-size: 16px;
    color: var(--active_color);
    padding-left: 6px;
    padding-top: 10px;
}
// 
.box_entress{
.select select{
        display: block;
        padding: 0px !important;
        width: 50px !important;
        height: 50px !important;
        text-align: center;
        background-color: var(--active_color) !important;
        border-color: var(--active_color) !important;
        color:black !important;
        border-radius: 100% !important;
         font-weight: 500 !important;
    }
     .select::after{
        border-color:black !important;
        right: 8px !important;
        z-index: 4 !important;
        top: 27px !important;
        font-size: 12px !important;
        }
}
</style>
<style lang="scss" scoped>
.tilbetailng{
   background-color: var(--active_color);
    color: #000;
    display: inline-flex;
    padding: 12px 20px;
    justify-content: space-between;
    align-content: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 25px;
    margin-top: -10px;
    margin-left: 0px;
    transition: 0.2s ease-in-out;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    width: 100%;
    text-align: center;
    justify-content: center;
    &:hover{
         color: #fff;
    }
}
@media(max-width:767px){
// .large_sm_ent , .small_sm_ent{
//     flex: 0 0 50%;
// }
.a_ent{
    display: block;
    flex: 0 0 100%;
    text-align: center;
}
.large_sm_ent{
    font-size: 15px;
}
.small_sm_ent{
font-size: 14px;
padding-top: 4px;
}
.tilbetailng{
font-size: 12px;
margin-left: 0px;
margin-top: 12px;
flex: 0 0 100%;
}
.title_text_ent{
        text-align: center;
        h1{
            font-size: 30px;
            color: var(--active_color);
            font-weight: 700;
            // text-shadow: 0px 1px 2px;
            // 
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-wrap: wrap !important;

        }
    }
}
.select_ddl{
    position: absolute;
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0
}
.entrees_cart_wrap{
    min-height: calc(100vh - 80px);
    padding-top: 30px;
    padding-bottom: 60px;
  .title_text_ent{
        text-align: center;
        h1{
            font-size: 30px;
            color: var(--active_color);
            font-weight: 700;
            // text-shadow: 0px 1px 2px;
            // 
            display: flex;
            justify-content: center;
            align-items: center;

        }
    }
    .title_group{
        margin-top: 20px;
        margin-bottom: 70px;
        h2{
        color: black;
        font-size: 17px;
        font-weight: 600;
        }
    }
    .box_entress{
                text-align: center;
                border:1px solid var(--active_color);
                // background-color: black;
                /* padding-bottom: 20px; */
                border-radius: 8px;
                // box-shadow: 4px 6px 4px -2px var(--active_color);
                position: relative;
            img{
                  width: 80px;
                    height: 80px;
                    object-fit: contain;
                    /* background-color: #e7d8c7; */
                    position: absolute;
                    top: -50px;
                    left: 0;
                    right: 0;
                    margin-left: auto;
                    margin-right: auto;
            }
         .name_entress{
            display: block;
            color: var(--active_color);
            font-size: 13px;
            font-weight: 600;
            padding-top: 40px;
            padding-bottom: 4px;
            text-shadow: 0px 1px 1px;
           }
             .price_entress{
            display: block;
            font-size: 19px;
            font-weight: 700;
            color: #000;
            padding-bottom: 22px;
                }
                .add_entrss{
                       margin-top: 10px;
                        border-radius: 100%;
                        width: 50px;
                        height: 50px;
                        position: absolute;
                        bottom: -30px;
                        left: 0;
                        right: 0;
                        margin-left: auto;
                        margin-right: auto;
                        box-shadow: 0px 3px 3px #200c00;
                        i{
                            color: black;
                        }
                }
  
    }
}
.box_single{
    margin-bottom: 95px;
}
.group_entress{
    margin-bottom: -50px;
}
</style>